import { render, staticRenderFns } from "./additional-info.vue?vue&type=template&id=2fa98773&scoped=true&"
import script from "./additional-info.vue?vue&type=script&lang=ts&"
export * from "./additional-info.vue?vue&type=script&lang=ts&"
import style0 from "./additional-info.vue?vue&type=style&index=0&id=2fa98773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa98773",
  null
  
)

export default component.exports